//export const API_CORE_URL = process.env.REACT_APP_API_CORE_URL || 'http://localhost:3556';
export const API_CORE_URL = process.env.REACT_APP_API_CORE_URL || 'https://api.psimammoliti.com';

/**
 * URL del backend nuevo de psi-platform (psiplatform-be).
 * En desarrollo apunta a localhost:3001 por defecto.
 * En staging/producción setear REACT_APP_PSI_PLATFORM_BE_URL.
 */
export const PSI_PLATFORM_BE_URL =
  process.env.REACT_APP_PSI_PLATFORM_BE_URL || 'http://localhost:3001';
export const PSYCHOLOGY_API_CORE_KEY = process.env.REACT_APP_PSYCHOLOGY_API_CORE_KEY || 'PACUo.rWd3NO6g0DmUHmL3TYHwp8wLTpFVptu5';
export const ADMIN_API_CORE_KEY = process.env.REACT_APP_PSYCHOLOGY_API_CORE_KEY || 'Eslvi.3grVElP1DYusjoWGowyU8R5E4qKwtJZC';

// Webhooks de Make (integraciones externas) — nunca hardcodear la URL en el componente
export const EMERGENCY_CONTACT_WEBHOOK = process.env.REACT_APP_EMERGENCY_CONTACT_WEBHOOK || '';
export const LIQUIDACIONES_WEBHOOK = process.env.REACT_APP_LIQUIDACIONES_WEBHOOK || '';
export const PROFILE_EDIT_WEBHOOK = process.env.REACT_APP_PROFILE_EDIT_WEBHOOK || '';
export const URGENT_PATIENTS_WEBHOOK = process.env.REACT_APP_URGENT_PATIENTS_WEBHOOK || '';
// Hardcodeado a propósito, sin variable de entorno (decisión de Agustín Troche, 09/2026):
// temporal, la Parte 2 de la migración de vacaciones reemplaza este webhook por código
// interno — no vale la pena una GitLab CI/CD Variable para algo de vida corta. Sin
// exposición extra: un REACT_APP_* termina en el bundle público exista o no como env var,
// así que esto no cambia nada a nivel seguridad, solo evita depender de que alguien la cargue.
export const VACATION_CREATE_WEBHOOK = 'https://hook.us1.make.com/6tlvpzh24980yodf9ri9vh6wormubv5a';

// Configuración de timeouts y reintentos
export const API_CORE_CONFIG = {
  TIMEOUT: 600000, // 600 segundos = 10 minutos
  MAX_RETRIES: 2,
  RETRY_DELAY: 30000, // 30 segundos
} as const;

// Configuración de Google OAuth 2.0
export const GOOGLE_AUTH_CONFIG = {
  // Client ID de Google Cloud Console
  CLIENT_ID: "996565287944-jp5jbodeedu4q9vqm60oopqq1bkeq3ci.apps.googleusercontent.com",
  
  // Endpoints correctos de Google OAuth 2.0
  ENDPOINTS: {
    AUTHORIZATION: 'https://accounts.google.com/o/oauth2/v2/auth',
    TOKEN: 'https://oauth2.googleapis.com/token',
    USERINFO: 'https://www.googleapis.com/oauth2/v2/userinfo',
    REVOKE: 'https://oauth2.googleapis.com/revoke'
  },
  
  // Scopes para obtener información básica del usuario
  SCOPES: [
    'https://www.googleapis.com/auth/userinfo.email',
    'https://www.googleapis.com/auth/userinfo.profile',
    'openid'
  ],
  
  // URI de redirección - debe coincidir con Google Console
  REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI || `${window.location.origin}/login`,
  
  // Configuración del popup
  POPUP_CONFIG: {
    width: 500,
    height: 600,
    left: (window.screen.width / 2) - 250,
    top: (window.screen.height / 2) - 300,
  },
  
  // Parámetros OAuth 2.0
  OAUTH_PARAMS: {
    response_type: 'token',
    include_granted_scopes: 'true',
    state: 'state_parameter_passthrough_value',
    prompt: 'select_account'
  }
};

// Tipos para la respuesta de Google
export interface GoogleUser {
  id: string;
  email: string;
  name: string;
  picture?: string;
  given_name?: string;
  family_name?: string;
  verified_email?: boolean;
}

export interface GoogleAuthResponse {
  credential: string;
  select_by: string;
  client_id: string;
}

export const SESSION_APPOINTMENT_TYPES = [
  { id: 'rec7Kx9JmE3aP2VQH', name: 'Individual', external_id: '11000001', duration: 60, clinical_service: "recAB6lTdBVtFxpdR" },
  { id: 'rec9LJ5E2xPIMa8R', name: 'Orientación vocacional', external_id: '11000003', duration: 60, clinical_service: "recBGrps7LnKgX3C8" },
  { id: 'recM2I7xE5J9aQLP', name: 'Orientación a padres', external_id: '11000004', duration: 60, clinical_service: "recgfkvniytpwucub" },
  { id: 'rec5ZP8JxIEM2a4V', name: 'Familia', external_id: '11000005', duration: 90, clinical_service: "recHODbz6KvjdU6JQ" },
  { id: 'recA4eI8ZxM2J5Wq', name: 'Talleres / charlas', external_id: '11000002', duration: 60, clinical_service: "recjgc7QLZVZvD1yi" },
  { id: 'recE5x2JIMa9P8L', name: 'Pareja', external_id: '11000007', duration: 90, clinical_service: "recVBX2xTPaaGcbZW"},
  { id: 'recIEM5Jx2aP8QL', name: 'Supervisión', external_id: '11000009', duration: 60, clinical_service: "recWqOnaDHtvTxLdR" },
  { id: 'rec8aP5JxI2EMQL', name: 'Material Digital', external_id: '11000008', duration: 60, clinical_service: "reczUfU6qcxk77y19" }
]
